import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Details } from "../../services/offer.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

export default function CouponDetails() {
  const { id } = useParams();

  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCoupon() {
      try {
        const response = await Details(id);
        if (response.success) {
          setCoupon(response.data); // single coupon object
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Failed to fetch coupon details",
            ...SWAL_SETTINGS,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: error?.response?.data?.message || "Something went wrong",
          ...SWAL_SETTINGS,
        });
      } finally {
        setLoading(false);
      }
    }
    fetchCoupon();
  }, [id]);

  if (loading) {
    return <div className="text-center py-5">Loading coupon details...</div>;
  }

  if (!coupon) {
    return <div className="text-center py-5">Coupon not found</div>;
  }

  return (
    <div className="main-content">
      <div className="Transactions-part">
    <div className="offer-details-part">
      <div className="card-box">
        <div className="row">
          <div className="col-md-3">
            <p className="text-color">Offer Title</p>
            <p className="subtitle-1 ps-3">{coupon?.name || "N/A"}</p>
  
            <p className="text-color">Offered Price</p>
            <p className="subtitle-1 ps-3">{coupon?.offered_price || "N/A"}</p>
  
            <p className="text-color">Description</p>
            <p className="subtitle-1 ps-3">{coupon?.description || "N/A"}</p>
          </div>
  
          <div className="col-md-3">
            <p className="text-color">Expiry Date</p>
            <p className="subtitle-1 ps-3">
              {coupon?.expiry_date ? new Date(coupon.expiry_date).toLocaleString() : "-"}
            </p>
  
            <p className="text-color">Created At</p>
            <p className="subtitle-1 ps-3">
              {coupon?.createdAt ? new Date(coupon.createdAt).toLocaleString() : "-"}
            </p>
  
            <p className="text-color">Updated At</p>
            <p className="subtitle-1 ps-3">
              {coupon?.updatedAt ? new Date(coupon.updatedAt).toLocaleString() : "-"}
            </p>
          </div>
        </div>
  
        <div className="d-flex mt-4 ms-3">
          <Link to="/business/coupons/1" className="btn btn-secondary me-2">
            Back
          </Link>
          <Link to={`/business/coupons/edit/${coupon._id}`} className="btn btn-light-purple">
            Edit
          </Link>
        </div>
      </div>
    </div>
    </div>
  </div>
  
  );
}
